import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import Actions from 'actions/Actions';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import GenericErrorModalEN from 'components/GlobalModals/GenericErrorModal/locales/GenericErrorModal_en_US';
import GenericErrorModalFR from 'components/GlobalModals/GenericErrorModal/locales/GenericErrorModal_fr_CA';

const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(GenericErrorModalEN, GenericErrorModalFR);

const { wrapHOC } = FrameworkUtils;

const localization = createStructuredSelector({
    title: getTextFromResource(getText, 'title'),
    header: getTextFromResource(getText, 'header'),
    content: getTextFromResource(getText, 'content'),
    cta: getTextFromResource(getText, 'cta')
});

const fields = createSelector(localization, textResources => {
    return {
        localization: textResources
    };
});

const functions = {
    requestClose: () => Actions.showGenericErrorModal({ isOpen: false })
};

const withGenericErrorModalProps = wrapHOC(connect(fields, functions));

export {
    withGenericErrorModalProps, fields, functions
};
